import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchSideContainer, MatchesSearchMemberContainer, NewMatchContainer } from './containers';
import MatchesActionCreators from './actions/MatchesActionCreators';
import MatchesStore from './stores/MatchesStore';
import SearchParamsStore from './stores/SearchParamsStore';

class MatchesSearchApp extends Component {
  filtersBtn = React.createRef();

  constructor(props) {
    super(props);

    const { noAboLimitReached } = props;

    MatchesStore.setNoAboLimitReached(noAboLimitReached);
    MatchesStore.setSearchMember(null);
    MatchesStore.setNextSearchMember(null);
    MatchesStore.setLoading(true);

    MatchesActionCreators.loadSearchMatchesMember();
  }

  handleFormSubmission = (query) => {
    if (typeof query === 'undefined') {
      // this.filtersBtn.current.scrollIntoView({ behavior: 'smooth', block: 'start'});
      this.filtersBtn.current.scrollIntoView();
    }

    const searchQuery = (typeof query === 'undefined') ? SearchParamsStore.getQuery() : query;

    MatchesStore.setSearchMember(null);
    MatchesStore.setNextSearchMember(null);
    MatchesStore.setLoading(true);
    MatchesStore.emitChange();

    MatchesActionCreators.loadSearchMatchesMember(searchQuery);
  };

  render() {
    const {
      myId,
      myImage,
      myStatus,
      needAbo,
      verificationRestrictions,
    } = this.props;

    return (
      <div>
        <div className="content-left block pam" style={{ marginBottom: '0.5rem', paddingBottom: '0.5rem', paddingTop: '0.5rem' }}>
          <SearchSideContainer
            submitForm={this.handleFormSubmission}
            type="matches"
          />
        </div>
        <div className="content-main matches-search">
          <MatchesSearchMemberContainer
            myId={myId}
            myImage={myImage}
            myStatus={myStatus}
            needAbo={needAbo}
            verificationRestrictions={verificationRestrictions}
          />
          <NewMatchContainer />
        </div>
      </div>
    );
  }
}

MatchesSearchApp.propTypes = {
  myId: PropTypes.string.isRequired,
  myImage: PropTypes.string,
  myStatus: PropTypes.string,
  needAbo: PropTypes.bool,
  verificationRestrictions: PropTypes.bool,
  noAboLimitReached: PropTypes.bool,
};

MatchesSearchApp.defaultProps = {
  myImage: '',
  myStatus: '',
  needAbo: false,
  verificationRestrictions: false,
  noAboLimitReached: false,
};

export default MatchesSearchApp;
